import { render, staticRenderFns } from "./BaseEditorHead.vue?vue&type=template&id=fc64507c&scoped=true&"
import script from "./BaseEditorHead.vue?vue&type=script&lang=js&"
export * from "./BaseEditorHead.vue?vue&type=script&lang=js&"
import style0 from "./BaseEditorHead.vue?vue&type=style&index=0&id=fc64507c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc64507c",
  null
  
)

export default component.exports